'use strict';
import _ from 'lodash';
import {vsprintf} from 'sprintf-js';

const messages = {
  'error.originalPassword.invalid': 'Nesprávne aktuálne heslo.',

  'error.confirmPassword.invalid': 'Heslá sa nezhodujú.',

  'error.auth.invalid': 'Neoprávnený prístup.',
  'error.auth.login': 'Neplatné prihlasovacie údaje.',

  'error.user.delete.myself': 'Nie je možné zmazať prihláseného užívateľa.',
  'error.user.edit.myself': 'Nie je možné editovať prihláseného užívateľa.',
  'error.user.activate': 'Nie je možné aktovať užívateľa.',
  'error.user.deactivate': 'Nie je možné deaktivovať užívateľa.',

  'error.activate.edit.myself': 'Nie je možné aktivovať prihláseného užívateľa.',
  'error.deactivate.edit.myself': 'Nie je možné deaktivovať prihláseného užívateľa.',

  'error.codeList.deactivate.invalid': 'Zneplatnenie položky nebolo možné vykonať.',

  'error.record.notFound': 'Záznam neexistuje.',
  'error.data.invalid': 'Dáta sa nepodarilo spracovať.',
  'error.data.integrity.violation': 'Akciu nie je možné vykonať, pretože by bola porušená integrita dát.',
  'error.data.integrity.violation.referenced': 'Položku nie je možné odstrániť, pretože je používaná v iných záznamoch.',
  'error.data.integrity.violation.duplicate': 'Akciu nie je možné vykonať. V aplikácii už existuje záznam s rovnakou hodnotou.',

  'error.pricelist.date.overlap': 'Platnosť cenníku sa prekrýva s iným existujúcim cennikom zákazníka.',
  'error.pricelist.date.invalid': 'Datum platnosti "od" nesmie byť neskôr ako dátum platnosti "do".',

  'error.customer.priceList.notExists': 'Zákazník "%(args[0].companyName)s" nemá platný cenník.',
  'error.customer.priceList.product.notExists': 'V cenníku zákazníka "%(args[0].companyName)s" chýba cena pre produkt "%(args[1].label)s".',

  'error.order.product.duplicate': 'Objednávka obsahuje položky s rovnakým produktom.',
  'error.order.empty': 'Objednávku nie je možné vytvoriť. Musí obsahovať aspoň jendu položku na objednanie alebo zadanú hotovosť.',

  'error.invoiceData.date.invalid': 'Datum "od" nesmie byť neskôr ako dátum "do".',

  'common.data.notRecords': 'Žiadny záznam neexistuje.',

  'codeList.delete.confirmation': 'Naozaj chcete odstrániť položku "%s"?',

  'priceList.delete.confirmation': 'Naozaj chcete odstrániť cenník pre "%s"?',

  'user.delete.confirmation': 'Naozaj chcete odstrániť užívateľa "%s"?',
  'user.delete.success': 'Uživateľ bol úspešne zmazaný?',
  'user.activate.success': 'Užívateľ bol úspešne aktivovaný.',
  'user.deactivate.success': 'Užívateľ bol úspešne deaktivovaný.',
  'user.edit.success': 'Užívateľ bol úspešne uložený.',

  'customer.delete.confirmation': 'Naozaj chcete odstrániť zákazníka "%s"?',
  'customer.edit.success': 'Zákazník bol uložený.'
};

export default {
  message(key, defaultMessageOrObjectArgs, defaultMessageParam) {
    const defaultMessage = _.isString(defaultMessageOrObjectArgs) ? defaultMessageOrObjectArgs : defaultMessageParam;
    let message = messages[key] || (defaultMessage ? (messages[defaultMessage] || defaultMessage) : key);
    if (_.isArray(defaultMessageOrObjectArgs)) {
      message = vsprintf(message, defaultMessageOrObjectArgs);
    }
    return message;
  }
}



// WEBPACK FOOTER //
// ./client/i18n/index.js